import React from 'react';
import { Volume2, VolumeX } from 'lucide-react';
import { useSound } from '../hooks/useSound';

export function MuteButton() {
  const { muted, toggleMute } = useSound();
  return (
    <button
      data-testid="mute-button"
      className="mute-btn"
      onClick={toggleMute}
      aria-label={muted ? 'Unmute' : 'Mute'}
    >
      {muted ? <VolumeX size={28} /> : <Volume2 size={28} />}
    </button>
  );
}
